import { CHARTER_COLORS as theme } from "../shared/controleTheme";
import { inputStyle } from "./bisLayoutStyles";
import { buttonBase } from "../shared/styles/layoutStyles";

export function productionSectionDescription(title) {
    const descriptions = {
        "Informations de lancement": "Synthèse opérationnelle de la production",
        Identification: "Identification et traçabilité du lot",
        "Production robot": "Données issues du robot de production",
        "Conditions de production": "Conditions environnementales relevées",
        "Residents a produire / reproduire": "Patients ajoutés ou repris pendant la production",
        "Incidents de production": "Événements rencontrés pendant la production",
        "IPC - IN PROCESS CONTROL (1 controle tous les 10 rouleaux)": "Contrôles qualité en cours de production",
        "Libération de lot": "Validation finale du dossier de lot",
        "Contrôle POUCH INSPECTOR": "Documents et éléments de contrôle final",
        "Réparation et controle final": "Actions post-production et pointage final",
    };
    return descriptions[title] || "";
}

export const productionInputStyle = {
    ...inputStyle,
    width: "100%",
    minHeight: "36px",
    padding: "8px 10px",
    borderColor: "#d6dee9",
};

export const productionAccordionTabStyle = {
    display: "grid",
    gap: "10px",
};

export const productionProgressPanelStyle = {
    display: "grid",
    gridTemplateColumns: "minmax(150px, 210px) minmax(120px, 1fr) 52px",
    alignItems: "center",
    gap: "14px",
    padding: "16px 22px",
    background: "white",
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    boxShadow: "0 4px 14px rgba(15, 23, 42, 0.04)",
};

export const productionProgressLabelStyle = {
    color: "#5A6D68",
    fontSize: "12px",
    fontWeight: 950,
    textTransform: "uppercase",
};

export const productionProgressTrackStyle = {
    height: "8px",
    borderRadius: "999px",
    background: "#dde8e4",
    overflow: "hidden",
};

export const productionProgressFillStyle = {
    display: "block",
    height: "100%",
    background: "#17B978",
};

export const productionProgressValueStyle = {
    color: "#0C3B3C",
    fontSize: "18px",
    fontWeight: 950,
    textAlign: "right",
};

export const productionDossierBlockStyle = active => ({
    border: "1px solid #dfe6e2",
    borderRadius: "8px",
    background: "white",
    overflow: "hidden",
    boxShadow: active ? "0 8px 22px rgba(12, 59, 60, 0.08)" : "0 1px 2px rgba(15, 23, 42, 0.04)",
});

export const productionDossierBlockButtonStyle = active => ({
    width: "100%",
    minHeight: "58px",
    border: 0,
    borderLeft: active ? "4px solid #17B978" : "4px solid transparent",
    padding: "13px 18px",
    display: "grid",
    gridTemplateColumns: "32px minmax(0, 1fr) auto 18px",
    gap: "12px",
    alignItems: "center",
    textAlign: "left",
    background: active ? "#e2f5ee" : "white",
    cursor: "pointer",
});

export const productionDossierBlockNumberStyle = complete => ({
    width: "28px",
    height: "28px",
    borderRadius: "999px",
    display: "grid",
    placeItems: "center",
    background: complete ? "#17B978" : "#e8efec",
    color: complete ? "white" : "#0C3B3C",
    fontSize: "12px",
    fontWeight: 950,
});

export const productionDossierBlockTitleStyle = {
    color: "#122A26",
    fontSize: "14px",
    fontWeight: 950,
    overflowWrap: "anywhere",
};

export const productionDossierBlockDescriptionStyle = {
    color: "#5A6D68",
    fontSize: "12px",
    fontWeight: 750,
    lineHeight: 1.35,
};

export const productionDossierBlockPillStyle = complete => ({
    justifySelf: "end",
    borderRadius: "999px",
    padding: "5px 10px",
    background: complete ? "#dff5ec" : "#efeee9",
    color: complete ? "#0d704a" : "#5A6D68",
    fontSize: "12px",
    fontWeight: 900,
    whiteSpace: "nowrap",
});

export const productionDossierBlockChevronStyle = {
    color: "#5A6D68",
    fontSize: "18px",
    lineHeight: 1,
};

export const productionDossierBlockContentStyle = {
    padding: "18px 20px 20px",
    borderTop: "1px solid #edf2ef",
    background: "white",
};

export const productionSectionStyle = {
    display: "grid",
    gridTemplateColumns: "250px minmax(0, 1fr)",
    gap: "22px",
    alignItems: "stretch",
    background: "white",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    padding: "22px",
    boxShadow: "0 10px 26px rgba(15, 23, 42, 0.05)",
};

export const productionSectionHeaderStyle = {
    display: "grid",
    gridTemplateColumns: "44px minmax(0, 1fr)",
    gap: "14px",
    alignItems: "start",
    minWidth: 0,
    paddingRight: "22px",
    borderRight: "1px solid #e2e8f0",
};

export const productionSectionNumberStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    background: theme.primary,
    color: "white",
    fontSize: "14px",
    fontWeight: 950,
    boxShadow: "0 8px 18px rgba(37, 99, 235, 0.24)",
    flexShrink: 0,
};

export const productionSectionMarkerPlaceholderStyle = {
    width: "38px",
    height: "38px",
    flexShrink: 0,
};

export const productionSectionTitleStyle = {
    margin: 0,
    color: "#0f172a",
    fontSize: "17px",
    fontWeight: 950,
    lineHeight: 1.25,
    letterSpacing: 0,
};

export const productionSectionDescriptionStyle = {
    margin: "18px 0 0",
    color: "#64748b",
    fontSize: "13px",
    fontWeight: 750,
    lineHeight: 1.45,
};

export const productionSectionContentStyle = {
    display: "grid",
    alignContent: "start",
    gap: "14px",
    minWidth: 0,
    paddingTop: "4px",
};

export const productionFieldGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "20px 28px",
    alignItems: "stretch",
};

export const productionLabelStyle = {
    display: "grid",
    alignContent: "start",
    gap: "7px",
    minWidth: 0,
    padding: 0,
    color: "#1e293b",
    fontSize: "13px",
    fontWeight: 950,
    lineHeight: 1.25,
};

export const productionRowsShellStyle = {
    display: "grid",
    gap: "8px",
};

export const productionRowsEmptyStyle = {
    padding: "14px",
    borderRadius: "8px",
    border: "1px dashed #cbd5e1",
    background: "#f8fafc",
    color: "#94a3b8",
    fontSize: "13px",
    textAlign: "center",
};

export const productionEditableRowStyle = {
    display: "grid",
    gap: "8px",
    alignItems: "end",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    background: "#f8fafc",
};

export const productionEditableFieldsStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
    gap: "8px",
    minWidth: 0,
};

export const productionRowIndexStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "30px",
    borderRadius: "999px",
    background: "white",
    border: "1px solid #dbe4ef",
    color: "#475569",
    fontSize: "12px",
    fontWeight: 950,
    alignSelf: "center",
};

export const productionRowDeleteButtonStyle = {
    ...buttonBase,
    width: "32px",
    height: "32px",
    padding: 0,
    background: "white",
    borderColor: "#fecaca",
    color: "#dc2626",
    fontSize: "18px",
    fontWeight: 900,
    alignSelf: "end",
};

export const productionAddRowButtonStyle = {
    ...buttonBase,
    minHeight: "34px",
    padding: "7px 12px",
    background: "#0f172a",
    borderColor: "#0f172a",
    color: "white",
    fontWeight: 900,
};

export const productionIncidentButtonStyle = (active, color) => ({
    ...buttonBase,
    background: active ? color : "white",
    borderColor: active ? color : "#cbd5e1",
    color: active ? "white" : "#0f172a",
    fontWeight: 900,
    minWidth: "84px",
});

export const validatePreProductionButtonStyle = {
    ...buttonBase,
    minHeight: "38px",
    padding: "8px 18px",
    background: theme.accent,
    borderColor: theme.accent,
    color: "white",
    fontWeight: 950,
    boxShadow: "0 6px 14px rgba(23, 185, 120, 0.18)",
};
